import { removeDecimals } from '../domain/calculatePrice';

const formatNumber = (content: number, digits: number): string => content.toLocaleString(undefined, { minimumFractionDigits: digits });
export default formatNumber;

export const formatPrice = (price: number): string => formatNumber(removeDecimals(price), 2);



// WEBPACK FOOTER //
// ./src/view/formatNumber.ts